/**
 * Property keys whose `=` operator uses Cloudscape's `tokenType:
 * "enum"` — the property renders a multi-select checkbox popover
 * with Cancel/Apply, and the Polaris token value is `string[]`.
 * `PropertyFilterInput` uses this set to bridge between the array
 * shape Polaris emits and the scalar-per-`PropertyFilter` shape the
 * rest of the app (query builder, URL round-trip) expects.
 *
 * Kept in its own module (no Polaris imports) so parser code and
 * unit tests can consume it without pulling in Cloudscape.
 */
export const MULTISELECT_PROPERTY_KEYS: ReadonlySet<string> = new Set([
  "country",
  "asinParty",
  "asinType",
  "programId",
  "productLineId",
  "baselineStatus",
  "validationStatus",
  "itemType",
  "catalogLiveness",
  "liveness",
  "makoWeblabStatus",
  "buyBoxStatus",
  "validationOverallStatus",
]);

/**
 * Group labels (`groupValuesLabel`) whose group-level "select all" toggle is
 * suppressed: these high-cardinality dynamic filters would generate a
 * select-all-sized query the backend cannot serve. Single source of truth —
 * `SearchPropertyFilter-config.tsx` uses these as the `groupValuesLabel`, and
 * the keyboard guard in `PropertyFilterInput.tsx` matches against them, so a
 * rename can't silently break the block. (The App.css hide rule needs the same
 * strings but cannot import TS — keep it in sync manually.)
 */
export const DISABLED_SELECT_ALL_GROUP_LABELS = [
  "Program values",
  "Product Line values",
];
